
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Josef G., 84 ans, décédé le 24 octobre 2020</b>
    <br />
    <br />
    <i>Sa femme témoigne:</i>
    <br />
    <p>
  «Mon mari a toujours été en pleine forme. L’été, nous aimions bien faire une
  promenade quotidienne de deux heures. Dès le début de la pandémie, il a fait
  attention. Il mettait un masque de protection au supermarché et partout où
  c’était recommandé. Une seule fois, c’était en octobre, il a oublié d’en
  porter un en public. C’est ce jour-là qu’il a été infecté. Une petite semaine
  plus tard, les premiers symptômes se sont manifestés: refroidissement,
  fatigue, rhume. Des maux de dos sont apparus. Des douleurs persistantes. J’ai
  alors décidé d’appeler notre médecin. Il nous a dit qu’il fallait en passer
  par là. Deux jours avant de mourir, mon mari s’est alité parce que ses
  douleurs dorsales étaient insupportables. Il avait déjà de la peine à parler.
  La fièvre s’est déclarée. J’ai appelé les urgences. Une heure plus tard, un
  médecin de l'unité de soins intensifs m'a appelée pour me dire que mon mari
  était condamné. Ses poumons étaient dans un très, très mauvais état. Le
  médecin nous a dit que la fin était proche. Ce fut un choc pour moi.
  Aujourd'hui, je sais que la pneumonie peut provoquer des douleurs dorsales.
  Mais à l’époque, nous ne le savions pas. Personne ne nous a aidés. Il a été
  même difficile de se faire tester. Moi aussi j'ai attrapé le virus, j'ai eu
  des difficultés respiratoires. On a refusé de me tester. C’est de la folie.
  Tout s’est passé si rapidement. Mon mari travaillait tout le temps. Il aidait
  toujours tout le monde. Il aimait vivre. Il ne voulait pas mourir.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;